import { render, staticRenderFns } from "./RegisterApplicantForm.vue?vue&type=template&id=88264d30"
import script from "./RegisterApplicantForm.vue?vue&type=script&lang=ts"
export * from "./RegisterApplicantForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports